import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {DashboardID} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './Greeting.style';
import {GreetingProps} from './Greeting.types';
import {renderedGreeting} from './Greeting.util';

export const Greeting = ({
  tt = withTranslation.ttDefaultProp,
  name,
  style: styleProp,
}: GreetingProps) => {
  return (
    <View
      style={get(styleProp, 'base')}
      accessible={true}
      accessibilityRole="header"
      accessibilityLabel={`${renderedGreeting(tt)} ${name}`}>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        accessible={true}
        // accessibilityLabel={`${renderedGreeting(tt)} ${name}`}
        testID={DashboardID.dashboardGreetingHello}
        style={styles.headerGreetingText}>
        {renderedGreeting(tt)}
      </Text>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        accessible={true}
        accessibilityLabel={name}
        testID={DashboardID.dashboardGreetingName}
        style={styles.headerGreetingText}>
        {name}
      </Text>
    </View>
  );
};

export default Greeting;
